

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 18"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M15.5.25c.75 0 1.3.03 1.77.1C20.59.71 21.25 2.7 21.25 6v6c0 3.3-.66 5.29-4.01 5.66-.44.06-.99.09-1.74.09h-9c-.75 0-1.3-.03-1.77-.1C1.41 17.29.75 15.3.75 12V6c0-3.3.66-5.29 4.01-5.66C5.2.28 5.75.25 6.5.25h9Zm.246 1.501L6.5 1.75c-.68 0-1.16.03-1.55.08-2.03.23-2.7.86-2.7 4.17v6c0 3.31.67 3.94 2.67 4.17.42.06.9.08 1.58.08h9c.68 0 1.16-.03 1.55-.08 2.03-.22 2.7-.86 2.7-4.17V6c0-3.31-.67-3.94-2.67-4.17a10.04 10.04 0 0 0-1.334-.079ZM16 11.75c.41 0 .75.34.75.75s-.34.75-.75.75H6.02c-.41 0-.76-.34-.76-.75s.33-.75.74-.75h10ZM9.11 6c.55 0 1 .45 1 1A1.005 1.005 0 0 1 8.1 7c0-.55.44-1 1-1h.01ZM6.1 6c.55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1-.45-1-1s.44-1 1-1Zm9.9.25c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H16Z"}, []), "\n"]);
};

        